import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/Bits";

const Restaurants = () => {
  useSeo({
    title: "Restaurants",
    description: "Built for the way restaurants actually run — discovery, table QR ordering, split checks, tipping, POS routing, and reservations.",
    path: "/restaurants",
  });

  return (
    <div>
      <PageHeader eyebrow="Restaurants" title="Built for the way restaurants actually run." testId="restaurants-hero" />
      <section>
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <div className="grid gap-6 lg:grid-cols-2 lg:gap-10">
            <Reveal>
              <div className="h-full rounded-lg border border-border bg-card p-8">
                <h2 className="font-display text-xl font-semibold">For guests</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  Find you in Discover, view the menu, scan the table QR to order, and when the meal's
                  done, split the check — whole table, their items, evenly, or by item — then tip
                  (100% to staff) and pay. A receipt lands in their activity.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.06}>
              <div className="h-full rounded-lg border border-border bg-card p-8">
                <h2 className="font-display text-xl font-semibold">For the restaurant</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  Manage menus, take table and pickup orders, associate orders to tables, route orders
                  to your POS (Square/Clover; Toast in progress), offer optional dollar rewards and
                  birthday rewards, and take reservations or run a waitlist where you enable them. Tips
                  route to the assigned server.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Restaurants;
